import { JSX } from 'react';
import { allIcons } from './icons';
import { AtText } from '../at-text';
import { IAtIconProps } from './at-icon.types';

export const AtIcon = ({
  icon,
  color,
  className,
  ...rest
}: IAtIconProps): JSX.Element => {
  const Icon = allIcons[icon];

  if (!Icon)
    return (
      <AtText size="sm" type="span">
        Selected icon was not found{' '}
      </AtText>
    );

  return (
    <Icon
      aria-hidden
      color={color}
      customClasses={className}
      data-testid={`at-icon-${icon}`}
      {...rest}
    />
  );
};
